import styled from 'styled-components';
import { getTaskDifficultyDisplayName, getTaskDifficultyIcon, TaskProps } from '../../services/task';
import Icon from '../../ui/Icon';
import Tooltip from '../../ui/Tooltip/Tooltip';

interface Props {
    duration?: TaskProps['duration'],
    difficulty?: TaskProps['difficulty'],
}

export default function TaskAttributes({ duration, difficulty }: Props) {

    function getDuration() {
        if (!duration) return '--';
        return duration > 60 ? (duration / 60).toFixed(1) + 'h' : duration + 'm';
    }

    return (
        <Wrapper className="task-atributes-container">
            <Tooltip title='Approx. duration'>
                <div className="task-time" title="Approx. duration">
                    <div className="task-time-icon"><Icon icon="time" size={13} /></div>
                    <div className="task-time-text">{getDuration()}</div>
                </div>
            </Tooltip>

            <Tooltip title={`Difficulty lvl. ${difficulty === undefined ? '?' : difficulty} (${getTaskDifficultyDisplayName(difficulty)})`}>
                <div className={`task-difficulty lvl-${difficulty}`} title={`Difficulty lvl. ${difficulty === undefined ? '?' : difficulty} (${getTaskDifficultyDisplayName(difficulty)})`}>
                    <div className="task-difficulty-icon unknown"><Icon icon={getTaskDifficultyIcon(difficulty)} size={20} /></div>
                </div>
            </Tooltip>

        </Wrapper>
    )
}

const Wrapper = styled.div`
    grid-area: attributes;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 10px; */

    .task-time {
        background-color: ${props => props.theme.backgroundColor};
        padding: 5px 10px;
        height: 32px;
        border-radius: ${props => props.theme.borderRadius};
        font-size: 12px;
        font-weight: 900;
        display: flex;
        align-items: center;
        color: #ccc;
        user-select: none;
        margin: 0 2px;
    }

    .task-time-icon {
        
    }

    .task-time-text {
        padding: 0 5px;
    }

    .task-difficulty {
        background-color: ${props => props.theme.backgroundColor};
        /* width: 32px; */
        padding: 0 6px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: ${props => props.theme.borderRadius};
        margin: 0 2px;
        user-select: none;

        &.lvl-0 { background-color: #1976d244; }
        &.lvl-1 { background-color: #00796b44; }
        &.lvl-2 { background-color: #fbc02d44; }
        &.lvl-3 { background-color: #e64a1944; }
        &.lvl-4 { background-color: #d32f2f44; }
    }

    .task-difficulty-text {
        font-size: 12px;
        font-weight: 900;
        color: #ccc;
        padding: 0 4px;
    }
`